import message from 'antd/lib/message';

import { batchActions } from 'redux-batched-actions';

import * as api from '../../api/apiko-api';
import { getResErrorMsg } from '../../utils';
import * as actions from '../actions/request-logs';
import * as requestsActions from '../actions/requests';


/**
 * handleRequestLogDelete :: (ID, Number) -> Func -> Promise Error _
 */
export const handleRequestLogDelete = (requestLogId, logsLength) => dispatch =>
  Promise.resolve(dispatch(actions.removeRequestLogRequest()))
    .then(() => api.deleteRequestLog(requestLogId))
    .then(({ requestLog }) => {
      message.success('Request log removed');
      return dispatch(batchActions([
        dispatch(actions.removeRequestLogSuccess(requestLog)),
        requestsActions.removeRequestLog({
          requestId: requestLog.requestId,
          requestLogId: requestLog._id,
        }),
        requestsActions.setCollapseKey({ arrayLength: logsLength - 1 }),
      ]));
    })
    .catch((error) => {
      dispatch(actions.removeRequestLogFailure());
      message.error(`Failed to delete request log: ${getResErrorMsg(error)}`);
    });



// WEBPACK FOOTER //
// ./src/redux/thunk/request-logs.js